import { PropsWithChildren, ReactNode } from 'react';
import { Disclosure, SimpleSummary } from 'corso-admin-ui';

export default function LineItemDisclosure({
  defaultOpen = false,
  title,
  supportingText,
  children,
}: PropsWithChildren<{
  defaultOpen?: boolean;
  title: string;
  supportingText?: ReactNode;
}>) {
  return (
    <div className="rounded-md border">
      <Disclosure
        defaultOpen={defaultOpen}
        renderSummary={() => (
          <SimpleSummary>
            <span className="grow text-sm text-neutral-500">{title}</span>
            {supportingText !== undefined && <div>{supportingText}</div>}
          </SimpleSummary>
        )}
      >
        <div className="flex flex-col gap-2 p-3 lg:gap-4 lg:p-4">
          {children}
        </div>
      </Disclosure>
    </div>
  );
}
